import React, { useEffect } from "react";
import Header from "../components/Header";
import Banner from "../components/Banner";
import Categorys from "../components/Categorys";
import FeatureProducts from "../components/products/FeatureProducts";
import Products from "../components/products/Products";
import Footer from "../components/Footer";
import { useDispatch, useSelector } from "react-redux";
import { get_banners, get_products } from "../store/reducers/homeReducer";

const Home = () => {
  const dispatch = useDispatch();
  const { products, latest_product, topRated_product, discount_product } =
    useSelector((state) => state.home);

  useEffect(() => {
    dispatch(get_products());
    dispatch(get_banners());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-full min-h-screen flex flex-col">
      <Header />

      {/* Main content area */}
      <main className="flex-grow">
        {/* Banner Section */}
        <section className="w-full py-8 px-4 sm:px-6 lg:px-8">
          <Banner />
        </section>

        {/* Categories Section */}
        <section className="w-full px-4 sm:px-6 lg:px-8 py-8">
          <Categorys />
        </section>

        {/* Featured Products Section */}
        <section className="py-8 px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <FeatureProducts products={products} />
          </div>
        </section>

        {/* Product Grid Section */}
        <section className="py-8">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
              {/* Latest Products */}
              <div className="overflow-hidden rounded-lg shadow-sm border border-gray-100">
                <Products title="Nuevos" products={latest_product} />
              </div>

              {/* Top Rated Products */}
              <div className="overflow-hidden rounded-lg shadow-sm border border-gray-100">
                <Products title="Populares" products={topRated_product} />
              </div>

              {/* Discounted Products */}
              <div className="overflow-hidden rounded-lg shadow-sm border border-gray-100">
                <Products title="Descuentos" products={discount_product} />
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Home;
